import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'
import { Location } from '@reach/router'

import Container from '../global/Container'
import Menu from '../global/Menu'

const HeaderComponent = ({ className }) => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled)
      }
    }
    document.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [scrolled])

  return (
    <Location>
      {({ location }) => {
        const inHome =
          location.pathname == '/' ||
          location.hash.includes('pages/entries/index')
            ? true
            : false
        const inAdmin = location.pathname.includes('admin') ? true : false
        return (
          <>
            <div
              className={`${className} ${scrolled ? '-scrolled' : ''}  ${
                inHome ? '-home' : ''
              } ${inAdmin ? '-admin' : ''}`}
            >
              <Container className="nav-container">
                <Menu />
              </Container>
            </div>
            <HeaderSpacer
              className={`header-spacer ${inHome ? '-home' : ''}`}
            />
          </>
        )
      }}
    </Location>
  )
}

HeaderComponent.propTypes = {
  className: PropTypes.string.isRequired,
}
const HeaderSpacer = styled.div`
  height: 0;
`

const Header = styled(HeaderComponent)`
  transition: all ease-in-out 0.2s;
  .logo {
    ${tw`mr-10 leading-none block`}
    transition: all ease-in-out 0.2s;
    height: 41px;
  }
  .logo svg {
    height: 100%;
    width: auto;
  }
  .nav-container {
    ${tw`flex relative justify-between items-center`}
  }
  .nav-link {
    ${tw`text-white no-underline px-5`}
  }
  ${tw`px-6 py-12`};
  &:not(.-admin) {
    ${tw`fixed top-0 z-20 w-full`}
  }
  &.-admin {
    ${tw`absolute top-0 z-20 w-full`}
  }
  &.-scrolled {
    background: rgb(217, 207, 199, 0.8);
    ${tw`pt-2`}
    padding-bottom: 0.7rem;
    .logo {
      margin-top: 20px;
      height: 36px;
    }
    .nav-link {
      ${tw`text-sm`}
    }
  }
`

export default Header
